import _ from 'lodash';

const column = (actionColumns, key) => _.find(actionColumns, c => c.key === key);

export const showActionColumn = (actionColumns, key) =>
  _.includes(column(actionColumns, key), true);
